import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.to-string";
import "regenerator-runtime/runtime";
import _get from "lodash/get";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import { getProviderDetails, selectProvider, startYodleeOnboarding } from "../actions/yodlee";
import { initializePortal, getPortalForInstitution } from "../actions/financial-data";
import { getSelectedProviderId, getShouldFetchPortalDetails, getShouldFetchProviderDetails, getShouldInitializePortal } from "../selectors";
import { FINANCIAL_PORTAL_PRIMARY_SOURCES, MARKETPLACE_INSTITUTION_AGGREGATOR_TYPES } from "../constants/account-aggregation";
/**
 * Listens for change to provider id and dispatches getProviderDetails or getPortalForInstitution if
 * necessary.
 * @name providerDetailsMiddleware
 * @type ReduxMiddleware
 */

export default (function (_ref) {
  var dispatch = _ref.dispatch,
      getState = _ref.getState;
  return function (next) {
    return (
      /*#__PURE__*/
      function () {
        var _ref2 = _asyncToGenerator(
        /*#__PURE__*/
        regeneratorRuntime.mark(function _callee(action) {
          var returnValue, state, providerId, isYodleeFdpInstitution;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  returnValue = next(action);
                  state = getState();

                  if (!(action.type !== selectProvider.getType() && action.type !== startYodleeOnboarding.getType())) {
                    _context.next = 4;
                    break;
                  }

                  return _context.abrupt("return", returnValue);

                case 4:
                  providerId = getSelectedProviderId(state.identity); // FDP supports Yodlee, but the login flow has not been ported and linking relies on the Yodlee login flow in identity

                  isYodleeFdpInstitution = false;

                  if (action.type === selectProvider.getType()) {
                    isYodleeFdpInstitution = _get(action, 'payload.aggregator') === MARKETPLACE_INSTITUTION_AGGREGATOR_TYPES.YODLEE;
                  } else if (action.type === startYodleeOnboarding.getType()) {
                    isYodleeFdpInstitution = _get(action, 'payload.primarySource') === FINANCIAL_PORTAL_PRIMARY_SOURCES.YODLEE;
                  }

                  if (!isYodleeFdpInstitution) {
                    if (getShouldInitializePortal(state.identity)) {
                      dispatch(initializePortal({
                        marketplaceInstitutionId: providerId
                      }));
                    } else if (getShouldFetchPortalDetails(state.identity)) {
                      dispatch(getPortalForInstitution({
                        marketplaceInstitutionId: providerId
                      }));
                    }
                  } else if (getShouldFetchProviderDetails(state.identity)) {
                    dispatch(getProviderDetails({
                      providerId: providerId
                    }));
                  }

                  return _context.abrupt("return", returnValue);

                case 9:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref2.apply(this, arguments);
        };
      }()
    );
  };
});